import React, { useEffect } from "react";
import { FormControl, Select, MenuItem, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { generateClient } from "aws-amplify/api";
import { genresByCategoryID } from "../../graphql/queries";
import { useDispatch } from "react-redux";
import {
  setCategory,
  setGenres,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import { WATCH, LISTEN, READ, DEVOTION, PLAY } from "../../constants";

const Category = ({ formik }) => {
  const client = generateClient();
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.contentForm.categories);
  const contentType = useSelector((state) => state.contentForm.contentType);
  
  const fetchGenres = async () => {
    if (categories.length) {
      const category = categories.find(
        (category) => category.title === formik.values.category
      );
      try {
        const response = await client.graphql({
          query: genresByCategoryID,
          variables: { categoryID: category.id },
        });
        const genres = response.data.genresByCategoryID.items;
        
        // Sort genres alphabetically - keeping this for genres
        const sortedGenresList = genres
          .map((genre) => genre.title)
          .sort((a, b) => a.localeCompare(b));
          
        dispatch(setGenres(sortedGenresList));
      } catch (error) {
        console.error("Error fetching genres:", error);
      }
    }
    return;
  };
  
  useEffect(() => {
    if (categories.length) {
      fetchGenres();
      dispatch(setCategory(formik.values.category));
    }
  }, [formik.values.category]);
  
  // Get ordered categories based on content type
  const getOrderedCategories = () => {
    // Custom order mapping for each content type
    const orderMappings = {
      [WATCH]: ["Movies", "Documentaries", "TV", "DreamKids", "DreamBites", "Short Film", "Sports", "Vodcast"],
      [LISTEN]: ["Music", "Podcasts", "Audio Books"],
      [READ]: ["E-Bookazines", "E-Magazines", "E-Books"],
      [DEVOTION]: ["Quran Majeed", "Hamd-o-Naat", "Qawaali","Hajj"]
      // Add other content types as needed
    };
    
    // Use custom ordering if there's a mapping for the current content type
    if (contentType && orderMappings[contentType]) {
      return orderMappings[contentType]
        .map(title => categories.find(category => category.title === title))
        .filter(Boolean); // Remove any undefined entries
    }
    
    // Default to alphabetical sort for content types not in the mapping
    return [...categories].sort((a, b) => a.title.localeCompare(b.title));
  };
  
  const orderedCategories = getOrderedCategories();
  
  return (
    <>
      <FormControl disabled={categories.length > 0 ? false : true} fullWidth>
        <label
          style={{
            margin: "10px 0",
            color: categories.length > 0 ? "inherit" : "lightgrey",
          }}
          htmlFor="category"
        >
          Category
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
        <Select
          id="category"
          name="category"
          style={{
            color: formik.values.category === "" ? "lightgrey" : "inherit",
          }}
          value={formik.values.category}
          onChange={formik.handleChange}
        >
          <MenuItem disabled value="">
            <em>Select Category</em>
          </MenuItem>
          {orderedCategories?.length > 0 &&
            orderedCategories?.map((i) => (
              <MenuItem key={i.id} value={i.title}>
                {i.title}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      {formik.touched.category && formik.errors.category && (
        <Typography sx={{ color: "red" }}>{formik.errors.category}</Typography>
      )}
    </>
  );
};

export default Category;